module.exports = __webpack_public_path__ + "static/cornwallis-73c1668aa3a8f0e660ffe6b945e6b775.jpg";